import Icon from '../../../../assets/icon-rule-engine.svg?react';
import {createRoute, editRoute} from './edit/routes';
import {AUTHORITY_READ_RULE} from '../../../../modules/ruleengine/config/consts';
import RuleList from '../../../../components/ruleengine/RuleList';
import showFunction from './showFunction';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'ruleengine',
	label: {
		id: 'assetgroup.detail.ruleengine.title',
		defaultValue: 'Rule Engine'
	},
	component: RuleList,
	iconSvg: Icon,
	childRoutes: [editRoute, createRoute],
	requiredAuthorities: [AUTHORITY_READ_RULE],
	config: {
		sidebarIndex: 4
	},
	show: showFunction
} satisfies RouteConfig;
